import { convertPrices } from '../utils/storefront'

export const productOnSale = (price, salePrice) => {
    if (!salePrice) return false

    const priceWithoutCurrency = parseFloat(price.replace(/[^0-9.]/g, ''))
    const salePriceWithoutCurrency = parseFloat(
        salePrice.replace(/[^0-9.]/g, '')
    )

    return (
        salePriceWithoutCurrency &&
        priceWithoutCurrency > salePriceWithoutCurrency
    )
}

export const sendKlevuAnalytics = (
    event,
    product,
    searchTerm = '',
    collection = false
) => {
    const apiKey = shopifyData.klevuApi.key

    if (!event || !apiKey || !product) {
        throw new Error('Missing required parameters for sendKlevuAnalytics()')
    }

    event.preventDefault()

    const analyticsUrl = [
        `https://stats.ksearchnet.com/analytics/${collection ? 'categoryProductClickTracking' : 'productTracking'}`,
        `?klevu_apiKey=${apiKey}`,
        `&klevu_type=clicked`,
        `&klevu_productId=${product.id}`,
        `&klevu_productGroupId=${product.itemGroupId}`,
        `&klevu_productVariantId=${product.id}`,
        `&klevu_productName=${encodeURIComponent(product.name)}`,
        `&klevu_productUrl=${encodeURIComponent(product.url)}`,
    ]

    if (searchTerm)
        analyticsUrl.push(`&klevu_keywords=${encodeURIComponent(searchTerm)}`)

    fetch(analyticsUrl.join(''), {
        method: 'GET',
        headers: {},
    }).finally(() => (window.location = product.url))
}


export const sendRecsAnalyticsEvent = (eventType, listId, listName, listLogic, items) => {
    const apiKey = shopifyData.klevuApi.key
    if (!apiKey || !listId || !items?.length) return

    return fetch('https://stats.ksearchnet.com/analytics/collect', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify([{
            event: eventType,
            event_apikey: apiKey,
            event_list_id: listId,
            event_list_name: listName,
            event_list_logic: listLogic,
            currency: Shopify.currency?.active,
            items,
        }]),
    })
}

export const convertKlevuProductData = async (klevuProducts) => {
    const products = klevuProducts.map((product) => {
        const url = new URL(product.url)

        product.url = `${Shopify.routes.root}${url.pathname.replace(/^\//, '')}`
        product.price = product.price * 100
        product.salePrice = product.salePrice * 100
        product.imageUrl = product.imageUrl.replace('_medium', '')
        product.imageHover = product.imageHover.replace(
            '_medium',
            ''
        )
        product.variants =
            JSON.parse(product.additionalDataToReturn)?.variants ||
            []

        return product
    })

    const convertedProducts = await convertPrices(products)

    return convertedProducts
}
